import {
  Box,
  Button,
  ButtonGroup,
  HStack,
  Icon,
  IconButton,
  NativeSelect,
  Spacer,
  useDisclosure,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { t } from "i18next";
import { CreateOrUpdateDashboardModal } from "./CreateOrUpdateDashboardModal";
import { DashboardTypes } from "../../../../survey/models/Dashboard";
import { useStores } from "../../../../shared/stores/RootStore";
import { toast } from "../../../../shared/views/CustomToaster";
import { AddIcon, DeleteIcon, SaveIcon } from "../../../../shared/views/icons";
import { CustomMenu } from "../../../../shared/views/CustomMenu";

const i18prefix = "map:dashboard.header";

const DashboardHeaderBase: React.FC = () => {
  const { dashboardStore, surveyStore } = useStores();
  const selectedSurvey = surveyStore.getSelected();

  const dashboardModal = useDisclosure();

  const onDelete = () => {
    if (
      window.confirm(
        t(`${i18prefix}.delete.confirm`, {
          name: dashboardStore.selectedDashboard!.name,
        })
      )
    ) {
      dashboardStore
        .deleteDashboard(dashboardStore.selectedDashboard!.id)
        .then(() => toast("success", t(`${i18prefix}.delete.success`)))
        .catch(() => toast("error", t(`${i18prefix}.delete.error`)));
    }
  };

  return (
    <HStack
      p={4}
      gap={4}
      backgroundColor="white"
      position="sticky"
      top={0}
      zIndex={9}
    >
      <NativeSelect.Root size="sm" fontSize={"sm"} maxW="300px">
        <NativeSelect.Field
          value={dashboardStore.selectedDashboard?.id ?? undefined}
          onChange={(e) => dashboardStore.setSelectedDashboard(e.target.value)}
          placeholder={
            dashboardStore.dashboards.length
              ? t(`${i18prefix}.select`)
              : t(`${i18prefix}.selectEmpty`)
          }
        >
          {dashboardStore.dashboards.map((dashboard) => (
            <option value={dashboard.id} key={dashboard.id}>
              {dashboard.name}
            </option>
          ))}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>

      {selectedSurvey?.permissions.canManageResults && (
        <ButtonGroup
          size="sm"
          fontSize={"sm"}
          colorPalette="primary"
          variant="outline"
        >
          <Button flexGrow={1} onClick={dashboardModal.onOpen}>
            <Icon as={SaveIcon} /> {t(`${i18prefix}.saveBtn`)}
          </Button>
          <IconButton
            disabled={!dashboardStore.selectedDashboard}
            onClick={onDelete}
          >
            <Icon as={DeleteIcon} />
          </IconButton>
        </ButtonGroup>
      )}

      <Spacer />

      {selectedSurvey?.permissions.canManageResults && (
        <Box>
          <CustomMenu
            items={Object.values(DashboardTypes.ItemType).map((type) => ({
              disabled:
                type === DashboardTypes.ItemType.MiniMap &&
                !!dashboardStore.dashboardItems.find(
                  (item) => item.type === DashboardTypes.ItemType.MiniMap
                ),
              onClick: () =>
                dashboardStore.addDashboardItem(
                  DashboardTypes.getDefaultItemByType(type)
                ),
              text: t(`map:dashboard.${type}.title`),
              key: type,
            }))}
          >
            <Button size="sm" fontSize="sm" as={Button} colorPalette="primary">
              <Icon as={AddIcon} /> {t(`${i18prefix}.addChart`)}
            </Button>
          </CustomMenu>
        </Box>
      )}
      {dashboardModal.open && (
        <CreateOrUpdateDashboardModal onClose={dashboardModal.onClose} />
      )}
    </HStack>
  );
};

export const DashboardHeader = observer(DashboardHeaderBase);
